<template>
    <div class="container edit-flight">
        <div class="box">
            <div class="level">
                <div class="level-left">
                    <div class="level-item">
                        <div class="field">
<!--                            this.$router.push({name: 'Schedule', params: {date: this.SearchDate}}).catch(()=>{});   -->
                            <router-link :to="{ name: 'Schedule', params : {date:this.SearchDate}}" active-class="is-active">
                                <button class="button is-info">
                      <span class="icon">
                    <i class="fas fa-long-arrow-alt-left"></i></span>
                                    <span>Back To Schedule</span>
                                </button>
                                <span style="margin-left: 25px;"> Flight Key: </span>
                                <span> {{selectedFlight.fKeyForZip}} </span>
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="level-right">
                    <div class="mrgn has-text-weight-bold"><!--Force Lock Update-->
                        <p v-if="selectedFlight.manuelUpdate" >Managed by User</p>
                        <p v-else >Managed by Netline</p>
                    </div>
                    <div class="level-item">
                        <div class="field">
                            <div class="buttons has-addons is-right">
                                        <div @click="switchfunc(selectedFlight)">
                                            <img v-if="selectedFlight.manuelUpdate" src="../../../public/favicon/switchon.png" height="38" width="68"/>
                                            <img v-if="!selectedFlight.manuelUpdate" src="../../../public/favicon/switchoff.png" height="38" width="68"/>
                                        </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="columns">
                <div class="column">
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Carrier</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.carrier" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Flight Number</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.fno" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>
<!--                    <div class="field is-horizontal">-->
<!--                        <div class="field-label is-normal">-->
<!--                            <label class="label">Leg NO</label>-->
<!--                        </div>-->
<!--                        <div class="field-body">-->
<!--                            <div class="field">-->
<!--                                <div class="control">-->
<!--                                    <input class="input" type="text" v-model="selectedFlight.leG_NO" disabled>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->



                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Registration</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.acreg" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Leg Type</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <!--                                    <input class="input" type="text" v-model="selectedFlight.leG_NO" disabled>-->
                                </div>
                                <div class="select">
                                    <select v-model="selectedFlight.leG_TYPE" style = "width: 250px"  :disabled="selectedFlight.manuelUpdate == false">
                                        <option value="P">Position</option>
                                        <option value="C">Chart</option>
                                        <option value="J">Scheduled</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Leg State</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <!--                                    <input class="input" type="text" v-model="selectedFlight.leG_NO" disabled>-->
                                    <div class="select">
                                        <select v-model="selectedFlight.leG_STATE" style = "width: 250px" :disabled="selectedFlight.manuelUpdate == false">
                                            <option value="ARR">ARR</option>
                                            <option value="DEP">DEP</option>
                                            <option value="SKD">EKD</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">AC Owner</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.aC_OWNER" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Schedule Departure</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.sdep" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Schedule Arrival</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.sarr" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Actual Departure</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.adep" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Actual Arrival</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.aarr" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Schedule Departure Date</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control" >
                                    <datepicker v-model="selectedFlight.std"
                                                :config="{ dateFormat:'Y-m-d H:i', enableTime:true,static: true,wrap:true }" :class="{ 'pointer-events-none' : selectedFlight.manuelUpdate == false }">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Schedule Arrival Date</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <datepicker v-model="selectedFlight.sta"
                                                :config="{ dateFormat:'Y-m-d H:i', enableTime:true,static: true,wrap:true }" :class="{ 'pointer-events-none' : selectedFlight.manuelUpdate == false }">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Actual Departure Date</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <datepicker v-model="selectedFlight.atd"
                                                :config="{ dateFormat:'Y-m-d H:i', enableTime:true,static: true,wrap:true }" :class="{ 'pointer-events-none' : selectedFlight.manuelUpdate == false }">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Actual Arrival Date</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <datepicker v-model="selectedFlight.ata"
                                                :config="{ dateFormat:'Y-m-d H:i', enableTime:true,static: true,wrap:true }" :class="{ 'pointer-events-none' : selectedFlight.manuelUpdate == false }">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Captain 1</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.cP1" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Captain 2</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.cP2" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Captain 3</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.cP3" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Cabin List</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <input class="input" type="text" v-model="selectedFlight.cabinList" :disabled="selectedFlight.manuelUpdate == false">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>

                        <input type="text" v-model="selectedFlight.manuelUpdate" hidden>
                    </div>
                </div>
            </div>
        </div>

        <div class="box" v-if="selectedFlight.manuelUpdate">
            <div class="field animate__animated animate__fadeInDown">
                <div class="control">
                    <button class="button" :class="{'is-link' : !isLoading ,'is-success' : isLoading}" type="button"
                            @click="editFlight(selectedFlight)" :disabled="isLoading">
                            <span class="icon is-small">
                            <font-awesome-icon :icon="isLoading ? 'spinner' : 'check'" :spin="isLoading"/>
                            </span>
                        <span>Update</span>
                    </button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import EditFlightService from "../../services/editFlight.service";
    import Datepicker from 'vue-bulma-datepicker'
    import {loadingMixin} from "../../utils/mixins";

    import {mapState} from "vuex";

    export default {
        name: "EditFlight",
        mixins: [loadingMixin],
        data: function () {
            return {
                docState: false,
                id: this.$route.params.id,
                SearchDate : this.$route.params.SearchDate,
                Leg_No : this.$route.params.Leg_No,
                selectedFlight: {
                    fKey1: "",
                    leG_NO: 0,
                    std: "",
                    sta: "",
                    atd: "",
                    ata: "",
                    carrier: "",
                    fno: "",
                    suffix: "",
                    sdep: "",
                    sarr: "",
                    adep: "",
                    aarr: "",
                    acreg: "",
                    leG_TYPE: "",
                    leG_STATE: "",
                    aC_OWNER: "",
                    cP1: "",
                    cP2: "",
                    cP3: "",
                    cabinList : "",
                    manuelUpdate: "",
                    whoDidManual: "",
                },
            }
        },
        components: {
            Datepicker,
        },
        async created() {
           await this.getFlightbyLeg_No(this.Leg_No);
        },
        methods: {
            async getFlightbyLeg_No(Leg_No) {
                try {

                    //console.log(id + " Neymiş bu id bakalım :) edil flight");

                    var flightList = await EditFlightService.getSelectedFlight(Leg_No);
                    this.selectedFlight = flightList;
                    this.selectedFlight.fno = this.selectedFlight.fno + this.selectedFlight.suffix;
                    return flightList;
                } catch (e) {
                    this.$notify({title: "Error", text: "Error on getFlightbyLeg_No function "+e.message, type: "error"});
                }
            },

            async editFlight(form) {
                this.showLoading();
                try {
                    form.whoDidManual = this.user.full_name;
                    var result = await EditFlightService.editFlightForm(form);

                    var msg =result.toString().substring(0,1);

                    if (msg ==1)
                    {
                        this.$notify({title: "Success", text: result, type: "success"});
                    }
                    else
                    {
                        this.$notify({title: "Error on editFlightForm", text: result, type: "error"});
                    }

                    return result.data;
                } catch (e) {
                    this.$notify({title: "Error on editFlightForm", text: e.message, type: "error"});
                } finally {
                    this.hideLoading();
                }
            },

            async switchfunc(form)
            {
                // popup
               if (this.selectedFlight.manuelUpdate == true)
               {
                 await  this.$swal({
                       title: '<p style="text-align: left ;font-size: 22px;">You are about to reactivate Netline integration for this flight.Therefore, integration process will change data automaticaly if it is in update period.</p>',
                        html: '<p style="font-size: 24px"><b>Are you sure?</b></p>',
                       showCancelButton: true,
                       cancelButtonText: 'No',
                       cancelButtonColor: '#C5381A',
                       confirmButtonColor: '#1874DA',
                       confirmButtonText: 'Yes',
                   }).then((response) => {

                       if (response.value)
                       {
                           form.whoDidManual = this.user.full_name;
                           form.manuelUpdate = false;
                           try {
                               // this.setUserRole(this.userRoleForm)
                               EditFlightService.editFlightForceLockmodeOff_Sync(form);
                               this.selectedFlight.manuelUpdate = false;
                               this.$notify({
                                   title: "Success",
                                   text: "Now Netline flight integration is inactive. You can update netline manually.",
                                   type: "success"
                               });
                            // this.isActiveUserModal = false;
                           } catch (e) {
                               this.$notify({title: "Error", text: "Error on editFlightForceLockmodeOff_Sync " + e.message, type: "error"})
                           }
                       }

                   });
               }
               else if(this.selectedFlight.manuelUpdate == false)
               {
                   await  this.$swal({
                       title: '<p style="text-align: left;font-size: 22px;">You are about to deactivate Netline integration for this flight.Therefore, user will manage this record manually.</p>',
                       html: '<p style="font-size: 24px"><b>Are you sure?</b></p>',
                       showCancelButton: true,
                       cancelButtonText: 'No',
                       cancelButtonColor: '#C5381A',
                       confirmButtonColor: '#1874DA',
                       confirmButtonText: 'Yes',
                   }).then((response) => {
                       if (response.value)
                       {
                           form.whoDidManual = this.user.full_name;
                           form.manuelUpdate = true;
                           try {
                               // this.setUserRole(this.userRoleForm)
                               EditFlightService.editFlightForceLockmodeOff_Sync(form);
                               this.selectedFlight.manuelUpdate = true;
                               this.$notify({
                                   title: "Success",
                                   text: "Now Netline flight integration is active.",
                                   type: "success"
                               });
                               //     this.isActiveUserModal = false;
                           } catch (e) {
                               this.$notify({title: "Error", text:"Error on editFlightForceLockmodeOff_Sync "+ e.message, type: "error"})
                           }
                       }
                   });
               }
            },


        },
        computed : {
            ...mapState("auth",["user"]),



        }
    }
</script>

<style scoped>



    /* switch */

    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* swtch end */


    .top-level{

        z-index: 999;

    }

    .low-level{
        z-index: -999;
    }

    .input {
        max-width: 300px;
    }

    .label {
        width: 200px;
    }

    .flatpickr {
        cursor: pointer;
        width: 300px;
    }

    .edit-flight {
        border: 1px solid #f5f5f5;
        padding: 30px;
        background-color: whitesmoke;
        height: 700px;
    }

    .onoffswitch {
        position: relative;
        width: 90px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
    }

    .onoffswitch-checkbox {
        display: none;
    }

    .onoffswitch-label {
        display: block;
        overflow: hidden;
        cursor: pointer;
        border: 2px solid azure;
        border-radius: 20px;
    }

    .onoffswitch-inner {
        display: block;
        width: 200%;
        margin-left: -100%;
        transition: margin 0.3s ease-in 0s;
    }

    .onoffswitch-inner:before, .onoffswitch-inner:after {
        display: block;
        float: left;
        width: 50%;
        height: 30px;
        padding: 0;
        line-height: 30px;
        font-size: 14px;
        color: white;
        font-family: Trebuchet, Arial, sans-serif;
        font-weight: bold;
        box-sizing: border-box;
    }

    .onoffswitch-inner:before {
        content: "ON";
        padding-left: 10px;
        background-color: #3298dc;
        color: #FFFFFF;
    }

    .onoffswitch-inner:after {
        content: "OFF";
        padding-right: 10px;
        background-color: #f14668;
        color: #FFFFFF;
        text-align: right;
    }

    .onoffswitch-switch {
        display: block;
        width: 18px;
        margin: 6px;
        background: #FFFFFF;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 56px;
        border: 2px solid #999999;
        border-radius: 20px;
        transition: all 0.3s ease-in 0s;
    }

    .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
        margin-left: 0;
    }

    .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
        right: 0px;
    }
    .mrgn{
        margin-right: 15px;
    }

    .pointer-events-none {
        pointer-events: none;
    }

</style>
